// extracted by mini-css-extract-plugin
export default {"chevron":"styles_chevron__qb+b5","expanded":"styles_expanded__1+shA"};